import { CalendarCheck2 } from "lucide-react";
import { bookingProofImages } from "../data/media";

const ProofCard = ({ img, testId }) => (
  <div
    data-testid={testId}
    className="w-32 shrink-0 overflow-hidden rounded-xl border border-[rgba(201,162,75,0.25)] bg-[#111110] shadow-[0_8px_24px_rgba(0,0,0,0.45)] sm:w-40 lg:w-48"
  >
    <div className="aspect-[9/16]">
      <img
        src={img.src}
        alt={img.alt}
        className="h-full w-full object-cover"
        loading="lazy"
      />
    </div>
  </div>
);

const MarqueeRow = ({ images, direction, testId }) => {
  // Duplicate the set so the -50% translate loops seamlessly.
  const doubled = [...images, ...images];
  return (
    <div className="marquee" data-testid={testId}>
      <div className={`marquee-track ${direction === "right" ? "marquee-right" : "marquee-left"}`}>
        {doubled.map((img, i) => (
          <ProofCard
            key={`${img.src}-${i}`}
            img={img}
            testId={`${testId}-item-${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export const BookingProofSection = ({
  title = "Tests Successfully Secured",
  testId = "booking-proof",
}) => {
  return (
    <section className="border-t border-[rgba(201,162,75,0.22)] bg-[#0e0d0c]" data-testid={testId}>
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-[#c9a24b]" />
          <p className="section-label">Recent Driving Test Bookings</p>
        </div>
        <h2 className="font-display mt-5 max-w-2xl text-2xl text-[#f2ede3] sm:text-3xl">
          {title}
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#a09a8c]">
          Real booking confirmations secured for EDT clients — shown here as visual proof
          only, not a live booking system.
        </p>
      </div>

      {bookingProofImages.length === 0 ? (
        <div className="mx-auto max-w-6xl px-5 pb-16 sm:px-8">
          <div
            data-testid={`${testId}-empty`}
            className="border border-dashed border-[rgba(201,162,75,0.3)] px-6 py-14 text-center"
          >
            <CalendarCheck2 size={26} className="mx-auto text-[#c9a24b]" />
            <p className="mt-4 text-sm text-[#a09a8c]">
              Booking confirmation photos are being added shortly — check back soon.
            </p>
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4 pb-16 sm:pb-20" data-testid={`${testId}-wall`}>
          <MarqueeRow images={bookingProofImages} direction="left" testId={`${testId}-row-top`} />
          <MarqueeRow images={bookingProofImages} direction="right" testId={`${testId}-row-bottom`} />
        </div>
      )}
    </section>
  );
};
